import { AbstractDefaultPropsModel, TranslationColumnValueModel, UploadModel } from '@ckmk/angular';

export class PostCategoryModel extends AbstractDefaultPropsModel {
  /**
   * The category id
   * @protected
   */
  public get id(): string | undefined {
    return this.get('id');
  }
  public set id(id: string | undefined) {
    this.set('id', id);
  }

  /**
   * The category cover
   * @protected
   */
  public get cover(): UploadModel | undefined {
    return this.get('cover');
  }
  public set cover(cover: any) {
    this.setInstance('cover', UploadModel, cover);
  }

  /**
   * The category slug
   * @protected
   */
  public get slug(): string | undefined {
    return this.get('slug');
  }
  public set slug(slug: string | undefined) {
    this.set('slug', slug);
  }

  /**
   * The category title
   * @protected
   */
  public get title(): TranslationColumnValueModel | undefined {
    return this.get('title');
  }
  public set title(title: any | undefined) {
    this.setInstance('title', TranslationColumnValueModel, title);
  }

  /**
   * The category description
   * @protected
   */
  public get description(): TranslationColumnValueModel | undefined {
    return this.get('description');
  }
  public set description(description: any | undefined) {
    this.setInstance('description', TranslationColumnValueModel, description);
  }

  public constructor(data?: any) {
    super(data);
  }

  public override fullName(): TranslationColumnValueModel | string {
    return this.title || '';
  }

  protected override onClone(): this {
    return new PostCategoryModel({
      description: this.description?.clone(),
    }) as this;
  }
}
